import type {Brand, BrandKitWithAssets} from '@Components/mystuff-brands/brand-kits.types';
import {createBrandKitWithAssetsObject} from "@Libraries/brands-library";
import {useAppSelector} from '@/hooks';
import {useBrandContentMap} from "@Hooks/brands/useBrandContentMap";
import {useBrandLogosMap} from "@Hooks/brands/useBrandLogosMap";
import {useBrandColorsMap} from "@Hooks/brands/useBrandColorsMap";
import {useBrandFontsMap} from "@Hooks/brands/useBrandFontsMap";

export const useBrandKitsWithAssets = (): BrandKitWithAssets[] => {
  const brandKitsWithAssets: BrandKitWithAssets[] = [];
  const brandKits = useAppSelector(({brands}) => {
    return brands.brands as Brand[];
  });

    const brandContentMap = useBrandContentMap();
    const allBrandLogos = useBrandLogosMap();
    const allBrandColors = useBrandColorsMap();
    const allBrandFonts = useBrandFontsMap();

    brandKits.forEach(brandKit => {
        brandKitsWithAssets.push(createBrandKitWithAssetsObject({
            brandKit,
            brandContent: brandContentMap,
            brandLogosMap: allBrandLogos,
            brandColorsMap: allBrandColors,
            brandFontsMap: allBrandFonts
        }) as BrandKitWithAssets);
    })


  return brandKitsWithAssets;
};